import { GET_BUSINESS, GET_BUSINESS_BY_ID } from "../constants/index";

export const business = (
  state = { businesslist: [], businessbyid: {} },
  action,
) => {
  switch (action.type) {
    case GET_BUSINESS:
      return { ...state, businesslist: action.businesslist };
    case GET_BUSINESS_BY_ID:
      return { ...state, businessbyid: action.businessbyid };
    default:
      return state;
  }
};
